import { Stack, Skeleton, SxProps, Theme } from '@mui/material'

export const HorizontalSkeletonCard = ({ component, sx }: { component?: React.ElementType; sx?: SxProps<Theme> }) => {
  return (
    <Stack
      sx={{ bgcolor: (theme: Theme) => theme.palette.neutralLight[0], ...sx }}
      p={4}
      justifyContent="space-between"
      direction="row"
      alignItems="center"
      height={75}
      borderRadius={2}
      component={component ?? 'div'}
    >
      <Stack direction="column" gap={2} flex={1}>
        <Skeleton variant="text" width="60%" height={24} />
        <Skeleton variant="text" width="40%" height={20} />
      </Stack>
    </Stack>
  )
}
